import React from "react";
import { useSelector } from "react-redux";
/** Styles Import */
import "./Style.css";
/** Services Import */
import Commons from "../../Services/Common/Common";
import TranslationService from "../../Services/Translation/TranslationService";
/** Components Import */
import { Card, Button } from "react-bootstrap";
import AutoTranslate from "../../Components/AutoTranslate";
/** Icons Import */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight, faEllipsisVertical } from "@fortawesome/free-solid-svg-icons";

function Sections({ title = "", items = [], onMoreClick = () => {}, onItemClick = () => {} }) {
  const language = useSelector((state) => state.localStorage.language);

  return (
    <div>
      <div className='flex-between-center mb-2'>
        <span className='main-section-title'>
          <AutoTranslate targetLanguage={language.lang}>{title}</AutoTranslate>
        </span>
        <Button variant='text-primary' className='main-section-button' onClick={onMoreClick}>
          <AutoTranslate targetLanguage={language.lang}>더보기</AutoTranslate>
          <FontAwesomeIcon icon={faAngleRight} />
        </Button>
      </div>
      <div className='main-section-row'>
        {items.map((item, index) => (
          <React.Fragment key={index}>
            <Card className='main-section-card cursor-pointer' onClick={() => onItemClick(item)}>
              <Card.Img
                variant='top'
                src={item.image}
                style={{
                  borderRadius: "10px",
                  width: "100%",
                  aspectRatio: "16/9",
                  objectFit: "scale-down",
                  backgroundColor: "black",
                }}
              />
              <Card.Body className='flex-between'>
                <div>
                  <Card.Text className='main-section-card-text' style={{ fontSize: "1.2rem", fontWeight: "bold" }}>
                    <AutoTranslate targetLanguage={language.lang}>{item.title}</AutoTranslate>
                  </Card.Text>
                  <span className='main-section-card-date'>{item.date}</span>
                </div>
                <Button variant='text-primary'>
                  <FontAwesomeIcon icon={faEllipsisVertical} />
                </Button>
              </Card.Body>
            </Card>
            {/* 카드 사이에만 divider 추가 */}
            {index < items.length - 1 && <div className='main-section-divider' />}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}

export default Sections;
